export const TASK_FORM_VALIDATION_OWNER_REFERENCE_TYPE = 'TASK_FORM_VALIDATION_OWNER_REFERENCE_TYPE';
export const JITA_OWNER_ID = -1;